module.exports = __webpack_public_path__ + "static/the_hungry-dfbb59ad217829cfb86c6d20334d9b4a.png";